<template>
  <k-layout>
    <k-flex c1>
      <k-btn size="xs" @click="minus">-</k-btn>
    </k-flex>
    <k-flex c10>
      <k-text-field
        v-show="show"
        :label="label || title"
        v-model="val"
        :rules="rules"
        :required="required||false"
      ></k-text-field>
    </k-flex>
    <k-flex c1>
      <k-btn fab small @click="plus">+</k-btn>
    </k-flex>
  </k-layout>
</template>

<script>
import {EventMixin} from '@/lib/mixins.js';

export default {
  mixins: [EventMixin],
  props: [
    'value',
    'name',
    'label',
    'title',
    'required'
  ],
  methods: {
    check_val () {
      if (_.isEmpty(this.val)) {
        this.val = "0";
      }
    },
    plus () {
      this.check_val();
      this.val = parseInt(this.val, 10) + 1;
    },
    minus () {
      this.check_val();
      this.val = parseInt(this.val, 10) - 1;
    }
  },
  computed: {
    rules () {
      if(this.required) {
        return [
          v => !!v || this.label+' is required'
        ]
      }
      return [];
    },
    val: {
      get () {
        return _.get(this.value, this.name) || "0";
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
